import { jsx as _jsx } from "react/jsx-runtime";
import { cx } from "../lib/cx.js";
const LOCKUP_SRC = "/brand/evolua-hcm-logo.png";
const MARK_SRC = "/brand/evolua-hcm-mark.png";
export function BrandLogo({ size = "header", alt = "Evolua HCM", src, className, ...rest }) {
    const resolvedSrc = src ?? (size === "mark" ? MARK_SRC : LOCKUP_SRC);
    return (_jsx("img", { src: resolvedSrc, alt: alt, className: cx("evolua-brand-logo", `evolua-brand-logo--${size}`, className), ...rest }));
}
//# sourceMappingURL=BrandLogo.js.map